module.exports = __webpack_public_path__ + "img/pic-w-20.png";